import { useEffect, useRef } from 'react';

import { FAQ } from '@components/FAQ';
import { AccordionChangeHandler } from '@components/FAQ/types';
import { useIsInView } from '@hooks/useIsInView';
import { useTrackingContext } from '@tracking/Provider/Context';
import {
  useTrackSignupCbcFaqExpanded,
  useTrackSignupCbcFaqsDisplayedOnce,
} from '@tracking/trackingEvents';

import { faqSections } from './sections';

interface CashbackFAQProps {
  faqTopicsExpanded: string[];
  onAccordionChange: AccordionChangeHandler;
}

const CashbackFAQ: React.FC<CashbackFAQProps> = ({
  faqTopicsExpanded,
  onAccordionChange,
}) => {
  const faqRef = useRef<HTMLDivElement>(null);
  const isInView = useIsInView(faqRef);
  const { trackingContexts } = useTrackingContext();
  const trackFaqsDisplayed = useTrackSignupCbcFaqsDisplayedOnce();
  const trackFAQExpanded = useTrackSignupCbcFaqExpanded();

  useEffect(() => {
    if (isInView) {
      trackFaqsDisplayed({}, { contexts: trackingContexts });
    }
  }, [isInView, trackFaqsDisplayed, trackingContexts]);

  const trackQuestionExpanded = (question: string) => {
    trackFAQExpanded(
      {
        question,
      },
      { contexts: trackingContexts }
    );
  };

  const handleAccordionChange: AccordionChangeHandler = (
    question,
    isExpanded,
    slug
  ) => {
    onAccordionChange(question, isExpanded, slug);

    if (isExpanded) {
      trackQuestionExpanded(question);
    }
  };

  return (
    <FAQ
      ref={faqRef}
      sections={faqSections}
      expandedState={faqTopicsExpanded}
      onAccordionChange={handleAccordionChange}
    />
  );
};

export { CashbackFAQ };
